import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Navigate } from 'react-router-dom';
import { AccessService } from '@services';
import { LazyPage } from '@hocs';
import { Routes } from '@enums';
import { jsx as _jsx } from "react/jsx-runtime";
var HomePage = LazyPage('home', 'HomePage');
var UsersPage = LazyPage('users', 'UsersPage');
var appPrivateRoutes = [_objectSpread({
  name: Routes.Main,
  path: Routes.Main,
  element: /*#__PURE__*/_jsx(HomePage, {}),
  index: true
}, AccessService.getRouteAccessConfig(Routes.Main)), _objectSpread({
  name: Routes.Users,
  path: Routes.Users,
  element: /*#__PURE__*/_jsx(UsersPage, {}),
  index: false,
  inline: true
}, AccessService.getRouteAccessConfig(Routes.Users)), _objectSpread({
  name: Routes.All,
  path: Routes.All,
  element: /*#__PURE__*/_jsx(Navigate, {
    to: Routes.NotFound,
    replace: true
  }),
  index: false
}, AccessService.getRouteAccessConfig(Routes.All))];
export { appPrivateRoutes };